import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { resetContext, setSectionSelected } from 'store/globalState/global';
import { setBreadcrumb } from 'components/Navbar/modules';
import { getMyThinkChats } from 'modules/think-seeds/actions';
import { getMyThinkTanks, getAdditionalThinks } from 'components/ThinkTanks/modules/actions';
import { getInvitations, fetchUserChats } from 'modules/chats';
import { resetAll } from 'modules/steps/actions';
import Think from '../components';


function mapStateToProps(state) {
  return {
    app: state.app,
    chats: state.chats,
    user: state.session.user,
    literals: state.i18n.literals.think || {},
    myThinkChatsList: state.thinkChats.myThinkChatsList,
    myThinkChatsStatus: state.thinkChats.myThinkChatsStatus,
    requestsJoinThinkTank: state.thinkTanks.requestsJoinThinkTank,
    myThinkTanksList: state.thinkTanks.myThinkTanksList,
    myThinkTanksStatus: state.thinkTanks.myThinkTanksStatus,
    myAdditionalThinks: state.thinkTanks.myAdditionalThinks,
    myAdditionalThinksStatus: state.thinkTanks.myAdditionalThinksStatus,
    invitationsList: state.chats.invitations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetContext: bindActionCreators(resetContext, dispatch),
    getMyThinkChats: bindActionCreators(getMyThinkChats, dispatch),
    getMyThinkTanks: bindActionCreators(getMyThinkTanks, dispatch),
    getInvitations: bindActionCreators(getInvitations, dispatch),
    setSectionSelected: bindActionCreators(setSectionSelected, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
    fetchUserChats: bindActionCreators(fetchUserChats, dispatch),
    getAdditionalThinks: bindActionCreators(getAdditionalThinks, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Think));



// WEBPACK FOOTER //
// ./src/routes/Think/container/index.js